const firebase = require("firebase/app");
require("firebase/auth");
require("firebase/database");

const send_suggestion = async (arg) => {
  const box = {
    uid: firebase.auth().currentUser.uid,
    email: firebase.auth().currentUser.email,
    type: arg.type,
    content: arg.content,
  };
  var wishRef = firebase.database().ref("suggestions/");

  try {
    await wishRef.push(box);
  } catch (e) {
    console.error(e);
    return false;
  }
  console.log("success")
  return true;
};

export default send_suggestion;
